var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TitleCom",class:{m_title:_vm.$store.state.screenType,en_title:_vm.$store.state.language}},[_c('span',[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }